import { GA_MEASUREMENT_ID } from '@/utils/ga'
import { useEffect } from 'react'

const GA_SCRIPT_ID = 'google-analytics-script'

const GoogleAnalyticsScript: React.FC = () => {
  useEffect(() => {
    if (typeof window === 'undefined' || GA_MEASUREMENT_ID.trim() === '') {
      return
    }

    window.dataLayer = window.dataLayer ?? []
    window.gtag = window.gtag ?? function (...args: unknown[]) {
      window.dataLayer?.push(args as unknown as Record<string, unknown>)
    }

    window.gtag('js', new Date())
    window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false })

    if (document.getElementById(GA_SCRIPT_ID) != null) {
      return
    }

    const script = document.createElement('script')
    script.id = GA_SCRIPT_ID
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
    document.head.appendChild(script)
  }, [])

  return null
}

export default GoogleAnalyticsScript
